import React from 'react';
import { GetServerSideProps } from 'next';

import { formatLanguageCodeInUrl, formatReqUrl, getCurrentRegion, getLanguageInURL } from '@source/utils/utils';
import { CARRO_MOBILE_APP_KEY, COOKIE_KEYS } from '@source/constants/common';
import { TLanguageKey, TRegionKey } from '@source/interface';

import { CCPOPageContainer } from '@source/pages/CarroCertified';
import { SUPPORTED_COUNTRIES } from '@source/constants/config';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const CarroCertifiedPage = ({ region }: { region: TRegionKey }) => <CCPOPageContainer region={region} />;

export const getServerSideProps: GetServerSideProps = async ({ locale, req }) => {
  // Todo: Mostly copy paste below pieces of code from home GetServerSideProps first.
  // might need to update getCurrentRegion or create a new one for getting region and isFromMobileApp
  const isFromMobileApp = req.cookies?.[CARRO_MOBILE_APP_KEY] === 'true';
  const cookieRegion = req.cookies?.[COOKIE_KEYS.STORED_REGION];
  const currentRegion = await getCurrentRegion({
    urlRegion: locale as TRegionKey,
    cookieRegion: cookieRegion as TRegionKey,
  });
  const urlLanguage = getLanguageInURL(formatReqUrl(req?.url as string, locale as TRegionKey));
  const lang = formatLanguageCodeInUrl(urlLanguage as TLanguageKey);

  // temporarily force ms to ms-SG for i18n key mapping
  // since RegionProvider already map ms to ms-SG for sg region
  const customLang = currentRegion === SUPPORTED_COUNTRIES.SG.code && lang === 'ms' ? 'ms-SG' : lang;

  return {
    props: {
      region: currentRegion,
      isFromMobileApp,
      lang,
      ...(await serverSideTranslations(customLang)),
    },
  };
};

export default CarroCertifiedPage;
